import { useEffect, useState } from "react";
import PediPlayPageHeader from "../../Shared/UI/PediplayPageHeader";
import { GetClientsByTherapist } from "../../Shared/Services";
import { Button, Col, message, Row, Tabs, Tooltip } from "antd";
import { ExportOutlined, EyeOutlined, FilePdfOutlined } from "@ant-design/icons";
import { iconSize } from "../../Shared/UI/jsx";
import { exportToCSV } from "../../Shared/Functions";
import TherapistClientTable from "./TherapistClientTable";
import { useCurrentUser } from "../../Shared/Contexts/UserContext";
import TherapistClientForm from "./Form";
import DocumentFinderModal from "../../Shared/Components/DocumentFinderModal";

const TherapistClients = props => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [highlighted, setHighlighted] = useState();
    const [visible, setVisible] = useState();
    const [activeTab, setActiveTab] = useState("0");
    const [docModalVisible, setDocModalVisible] = useState(false);

    const user = useCurrentUser();

    useEffect(() => {
        GetClientsByTherapist(user.therapistId ? user.therapistId : 0)
            .then((res) => {
                console.log("Response", res);
                setData(res.data);
                setHighlighted(res.data[0]);
            })
            .finally(() => {
                setLoading(false);
            })
    }, []);

    const handleRowOnClick = record => {
        setHighlighted(record);
    }

    const handleView = () => {
        setVisible(true);
    }

    const isActiveTab = Number(activeTab) === 0;
    const activeCount = Array.isArray(data) ? data.filter(r => r.active === true).length : 0;
    const inactiveCount = Array.isArray(data) ? data.filter(r => r.active === false).length : 0

    const filteredData = Array.isArray(data)
    ? data.filter(r => r.active === isActiveTab)
    : [];


    const extra = (
        <div style={{ textAlign: 'end' }}>
            <Tooltip title="View" placement="top">
                <Button
                    type="link"
                    icon={<EyeOutlined style={iconSize} />}
                    onClick={() => handleView()}
                />    
            </Tooltip>
            <Tooltip title="Documents" placement='top'>
                <Button
                    type='link'
                    icon={<FilePdfOutlined style={iconSize} />}
                    onClick={() => {
                        if (!highlighted) {
                            message.error("Please select a client first");
                            return;
                        }
                        setDocModalVisible(true);
                    }}
                />    
            </Tooltip>
            <Tooltip title="Export" placement="top">
                <Button
                    type="link"
                    icon={<ExportOutlined style={iconSize} />}
                    onClick={() => exportToCSV("Clients.csv", data)}
                />    
            </Tooltip>
            <TherapistClientForm
                visibility={visible}
                setVisibility={setVisible}
                highlighted={highlighted}
            />
            <DocumentFinderModal
                visible={docModalVisible}
                onClose={() => setDocModalVisible(false)}
                record={highlighted}
            />  
        </div>
    );

    return (
        <div>
            <Row gutter={[8,8]}>
                <Col span={24}>
                    <PediPlayPageHeader
                        title={'Clients For Therapist'}
                        props={props}
                        loading={loading}
                        extra={extra}
                    />
                </Col>
                <Col span={24}>
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={[
                            { key: "0", label: "Active Clients" },
                            { key: "1", label: "Inactive Clients" }
                        ]}
                    />    
                </Col>
                <Col span={24}>
                    <div
                        style={{
                            padding: "12px 16px",
                            background: "#fafafa",
                            borderRadius: 6,
                            border: "1px solid #e8e8e8",
                            marginBottom: 12,
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: 16,
                            fontWeight: 500
                            }}
                    >
                        <div>Active Clients: {activeCount}</div>
                        <div>Inactive Clients: {inactiveCount}</div>
                    </div>    
                </Col>
                <Col span={24}>
                    <TherapistClientTable clients={filteredData} loading={loading} highlighted={highlighted} handleRowOnClick={handleRowOnClick} />
                </Col>
            </Row>
        </div>
    );
}

export default TherapistClients;